import React from 'react';
import { Link, Meta, Title } from 'react-head';
import { useFlag } from '../redux/flags/hooks/useFlag';
export var CommonHelmet = function (_a) {
    var pageTitle = _a.pageTitle, _b = _a.pageDescription, pageDescription = _b === void 0 ? "DeviantArt is the world's largest online social community for artists and art enthusiasts, allowing people to connect through the creation and sharing of art." : _b, pageUrl = _a.pageUrl, _c = _a.pageThumb, pageThumb = _c === void 0 ? 'https://st.deviantart.net/minish/main/logo/card_black_large.png' : _c, isMobile = _a.isMobile, environment = _a.environment;
    return (React.createElement(React.Fragment, null,
        React.createElement(Meta, { charSet: "utf-8" }),
        React.createElement(Title, null, pageTitle),
        preconnectDomains(),
        preloadFonts(),
        React.createElement(Link, { rel: "apple-touch-icon", sizes: "180x180", href: "https://st.deviantart.net/eclipse/icons/ios-180.png" }),
        React.createElement(Link, { rel: "apple-touch-icon", sizes: "152x152", href: "https://st.deviantart.net/eclipse/icons/ios-152.png" }),
        React.createElement(Link, { rel: "apple-touch-icon", sizes: "120x120", href: "https://st.deviantart.net/eclipse/icons/ios-120.png" }),
        React.createElement(Link, { rel: "apple-touch-icon", sizes: "76x76", href: "https://st.deviantart.net/eclipse/icons/ios-76.png" }),
        React.createElement(Link, { rel: "icon", sizes: "192x192", href: "https://st.deviantart.net/eclipse/icons/android-192.png" }),
        React.createElement(Link, { rel: "icon", sizes: "144x144", href: "https://st.deviantart.net/eclipse/icons/android-144.png" }),
        React.createElement(Link, { rel: "icon", sizes: "96x96", href: "https://st.deviantart.net/eclipse/icons/android-96.png" }),
        React.createElement(Link, { rel: "icon", sizes: "48x48", href: "https://st.deviantart.net/eclipse/icons/android-48.png" }),
        React.createElement(Link, { rel: "mask-icon", href: "https://st.deviantart.net/eclipse/icons/touchbar-mark.svg", color: "#00e59b" }),
        React.createElement(Link, { rel: "icon", sizes: "16x16", type: "image/png", href: "https://st.deviantart.net/eclipse/icons/favicon-16x16.png" }),
        React.createElement(Link, { rel: "icon", sizes: "32x32", type: "image/png", href: "https://st.deviantart.net/eclipse/icons/favicon-32x32.png" }),
        React.createElement(Link, { href: getFavIcon(environment), rel: "shortcut icon" }),
        React.createElement(Link, { rel: "canonical", href: pageUrl }),
        React.createElement(Meta, { name: "application-name", content: "DeviantArt" }),
        React.createElement(Meta, { name: "description", content: pageDescription }),
        React.createElement(Meta, { property: "og:type", content: "website" }),
        React.createElement(Meta, { property: "og:url", content: pageUrl }),
        React.createElement(Meta, { property: "og:title", content: pageTitle }),
        React.createElement(Meta, { property: "og:image", content: pageThumb }),
        React.createElement(Meta, { property: "og:description", content: pageDescription }),
        React.createElement(Meta, { property: "fb:page_id", content: "6452638289" }),
        React.createElement(Meta, { property: "twitter:account_id", content: "1239671" }),
        React.createElement(Meta, { name: "twitter:site", content: "@deviantart" }),
        React.createElement(Meta, { name: "twitter:card", content: "summary_large_image" }),
        React.createElement(Meta, { name: "twitter:title", content: pageTitle }),
        React.createElement(Meta, { name: "twitter:description", content: pageDescription }),
        React.createElement(Meta, { name: "twitter:image", content: pageThumb }),
        React.createElement(Meta, { name: "theme-color", content: '#00e59b' /* G3 */ }),
        isMobile && (React.createElement(Meta, { name: "viewport", content: "width=device-width, initial-scale=1" })),
        React.createElement(Link, { href: "https://st.deviantart.net/native/journal_thumbs.css?8", rel: "stylesheet" }),
        useFlag('progressive_web_app') && (React.createElement(Link, { rel: "manifest", href: "/manifest.json" }))));
};
CommonHelmet.displayName = 'CommonHelmet';
// We preload just the woff2, they are better compressed and have good support
// especially on browsers that support preload :)
function preloadFonts() {
    var fonts = [
        [
            'https://st.deviantart.net/misc/symbols/deviantart-symbols6.woff2',
            'font/woff2',
        ],
        [
            'https://st.deviantart.net/fonts/calibre/calibre-bold.woff2',
            'font/woff2',
        ],
        [
            'https://st.deviantart.net/fonts/calibre/calibre-regular.woff2',
            'font/woff2',
        ],
        [
            'https://st.deviantart.net/fonts/calibre/calibre-semibold.woff2',
            'font/woff2',
        ],
        [
            'https://st.deviantart.net/fonts/calibre/calibre-medium.woff2',
            'font/woff2',
        ],
        [
            'https://st.deviantart.net/fonts/helvetica/helvetica_neue.woff2',
            'font/woff2',
        ],
    ];
    return fonts.map(function (font) { return (React.createElement(Link, { key: font[0], rel: "preload", href: font[0], as: "font", type: font[1], crossOrigin: 'anonymous' })); });
}
function preconnectDomains() {
    var domains = [
        'https://a.deviantart.net',
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com',
        'https://st.deviantart.net',
        'https://static.parastorage.com',
    ];
    return domains.map(function (domain) { return (React.createElement(Link, { key: domain, rel: "preconnect", href: domain })); });
}
function getFavIcon(env) {
    switch (env) {
        case 'dev':
            return 'https://i.deviantart.net/icons/da_favicon_vm.ico';
        case 'rc':
            return 'https://i.deviantart.net/icons/da_favicon_staging.ico';
        default:
            return 'https://st.deviantart.net/eclipse/icons/da_favicon.ico?1';
    }
}
export default CommonHelmet;
//# sourceMappingURL=Head.js.map